import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles'; // scoobydoo
import { createTheme, ThemeProvider  } from "@material-ui/core";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function CustomizedSnackbars() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [serverity, setSeverity] = React.useState("success")
  const [messageText, setMessageText] = React.useState("Your Translation has been processed!")

  const handleClick = () => {
    setOpen(true);
    setTimeout(function(){
      setSeverity("info")
      setMessageText("Please check your email for confirmation")
      setTimeout(function(){
        setSeverity("success")
        setMessageText("Your Translation has been processed!")
      },4000)
    },4000)
    
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <ThemeProvider theme={useStyles}>
    <div>{/* className={classes.root}>*/}
      <Button variant="outlined" onClick={handleClick}>
        Open success snackbar
      </Button>
      <Snackbar open={open} autoHideDuration={8000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={serverity}>
          {messageText}
        </Alert>
      </Snackbar>
      {/*<Alert severity="error">This is an error message!</Alert>
      <Alert severity="warning">This is a warning message!</Alert>
      <Alert severity="info">This is an information message!</Alert>
  <Alert severity="success">This is a success message!</Alert>*/}
    </div>
    </ThemeProvider>
  );
}
